import { render, staticRenderFns } from "./Damage.vue?vue&type=template&id=452671c8&scoped=true"
import script from "./Damage.vue?vue&type=script&lang=js"
export * from "./Damage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452671c8",
  null
  
)

export default component.exports